import { Component, HostListener, Inject, OnDestroy, OnInit, signal, computed, inject, DestroyRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EnableCookiesDialogData } from '../../dialogs-data/enable-cookies-dialog-data';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-enable-cookies-dialog',
    templateUrl: './enable-cookies-dialog.component.html',
    standalone: true,
    imports: [
        CommonModule,
        MatButtonModule,
        MatDialogModule,
        MatIconModule
    ]
})
export class EnableCookiesDialogComponent implements OnInit, OnDestroy {
    private destroyRef = inject(DestroyRef);
    private matDialogRef = inject(MatDialogRef<EnableCookiesDialogComponent>);

    @Inject(MAT_DIALOG_DATA)
    public enableCookiesDialogData: EnableCookiesDialogData;

    // Signals for reactive state
    private isVisible = signal<boolean>(true);

    // Computed properties
    isDialogVisible = computed(() => this.isVisible());

    constructor() {
    }

    ngOnInit() {
    }

    close(value: any) {
        this.isVisible.set(false);
        this.matDialogRef.close(value);
    }

    @HostListener('keydown.esc')
    public onEsc() {
        this.close('ESC keydown');
    }

    ngOnDestroy() {
    }
}
